import * as React from 'react';
import './MSRPToggle.scss';
import ToggleSwitch from '../common/ToggleSwitch/ToggleSwitch';

interface IMSRPToggleProps {
  showOnlyMSRP: boolean;
  isLoggedIn: boolean;
  toggleMSRP(): void;
  t?: any;
}

export class MSRPToggle extends React.Component<IMSRPToggleProps, any> {
  constructor(props: any) {
    super(props);
  }

  private handleOnButtonChange = () => {
    this.props.toggleMSRP();
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-msrp-toggle-section">
        {this.props.isLoggedIn && (
          <button className="rp-msrp-toggle no-select"
           onKeyDown={(event:any) => {
            if(event.keyCode === 13) {
              this.props.toggleMSRP();
            } 
          }}
          >
            <ToggleSwitch
              key={+this.props.showOnlyMSRP}
              // {...this.props}
              enabled={this.props.showOnlyMSRP}
              handleOnButtonChange={this.handleOnButtonChange}
            />
            <div className="rp-msrp-toggle--label" aria-label="Hide product price and only show product MSRP">{t('common.msrpOnly')}</div>
          </button>
        )}
      </div>
    );
  }
}

export default MSRPToggle;
